'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './recipes.routes';

export class RecipesComponent {
    /*@ngInject*/
    constructor($http, $location, $stateParams, searchService, $state, $scope) {
        this.message = 'Hello';
        this.$http = $http;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.searchService = searchService;
        this.$state = $state;
        this.hasKey = false;
        this.$scope = $scope;
        this.filteredRecipes = [];
    }

    $onInit() {

        var params = this.searchService.getSearchParams();
        this.$scope.baseURL = this.searchService.getBaseURL();
        console.log(params);
        var key;

        //Check if key exists in service
        if (this.searchService.getKey()) {
            key = this.searchService.getKey();
            this.hasKey = true;
        } else if (this.$location.search().key) {
            key = this.$location.search().key;
            this.hasKey = true;
        } else {
            this.hasKey = false;
        }

        //If no key exists in url, add parameter
        if (!this.$location.search().key) {
            console.log(key);

            this.$location.search('key', key);
        }

        //Check if search parameter and key, and set url parameters 
        if (params.q && key) {
            this.$location.url('?q=' + params.q + '&key=' + key);
        } else if (params.category) {
            this.$location.url("?category=" + params.category + '&key=' + key);
        }

        //Check key for nav access
        this.$http.get(`${this.$scope.baseURL}/api/cw/client/${key}`)
            .then(response => {
                this.$scope.client = response.data[0];
                console.log(this.$scope.client);
            });
        var searchParams = this.$location.search();
        this.searchService.setKey(key);

        //Load main page if no search parameters
        if (_.isEmpty(searchParams)) {
            this.$state.go('main');
        }

        //If tag search, query db
        if (searchParams.q) {
            this.$http.get(`${this.$scope.baseURL}/api/recipes/tag/${searchParams.q}/${key}`)
                .then(response => {
                    console.log(response.data);
                    this.filteredRecipes = response.data;
                })
                .catch(err => {
                    console.log(err);
                })
        }
        //If category search, query db
        else if (searchParams.category) {
            this.$http.get(`${this.$scope.baseURL}/api/recipes/category/${searchParams.category}/${key}`)
                .then(response => {
                    console.log(response.data);
                    this.filteredRecipes = response.data;
                    console.log(JSON.parse(response.data[0].recipeTags));

                })
                .catch(err => {
                    console.log(err);
                    if (err.data === 'Forbidden') {
                        this.hasKey = false;
                    }
                })
        }
    }

    viewRecipe(data) {
        console.log(data);
        this.searchService.setRecipe(data);

        this.$state.go('recipe');
    }

    backToSearch(type) {
        this.$location.url('/#' + type);
        this.$anchorScroll(type);
    }
}

export default angular.module('connectwellTemplateApp.recipes', [uiRouter])
    .config(routes)
    .component('recipes', {
        template: require('./recipes.html'),
        controller: RecipesComponent,
        controllerAs: 'recipesCtrl'
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/recipes/recipes.component.js